import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import pluralize from 'pluralize';
import TimeDisplay from 'common/utils/Dates/TimeDisplay';
import CardDataItem from './CardDataItem';

const DateDetails = ({ starts_at, ends_at }) => {
  if (!starts_at) {
    return (
      <CardDataItem
        className="text-red"
        dataLabel="service-start-date-value"
        label="Service Delivery Date(s)"
        required
        value="Required"
      />
    );
  }

  if (ends_at) {
    return (
      <CardDataItem
        dataLabel="service-dates-value"
        label="Service Delivery Date(s)"
        value={`${moment(starts_at).utc().format('LL')} - ${moment(ends_at).utc().format('LL')}`}
      />
    );
  }

  return (
    <CardDataItem
      dataLabel="service-start-date-value"
      label="Service Delivery Date(s)"
      value={moment(starts_at).utc().format('LL')}
    />
  );
};

DateDetails.propTypes = {
  starts_at: PropTypes.string,
  ends_at: PropTypes.string,
};

DateDetails.defaultProps = {
  starts_at: null,
  ends_at: null,
};

const TimeBasedDetails = ({ service_duration_start_time, service_duration }) => {
  const timeDisplay = service_duration_start_time ?
    <TimeDisplay timestamp={service_duration_start_time} /> : 'N/A';

  const durationDisplay = (service_duration || service_duration === 0) ?
    `${service_duration} ${pluralize('minute', service_duration)}` : 'N/A';

  return (
    <>
      <CardDataItem
        label="Start Time of Service"
        value={timeDisplay}
      />
      <CardDataItem
        label="Service Duration"
        value={durationDisplay}
      />
    </>
  );
};

TimeBasedDetails.propTypes = {
  service_duration_start_time: PropTypes.string.isRequired,
  service_duration: PropTypes.number.isRequired,
};

const ServiceDates = ({
  startsAt,
  endsAt,
  serviceDuration,
  serviceDurationStartTime,
  paymentType,
}) => (
  <>
    <DateDetails starts_at={startsAt} ends_at={endsAt} />
    {paymentType === 'time_based' && (
      <TimeBasedDetails
        service_duration_start_time={serviceDurationStartTime}
        service_duration={serviceDuration}
      />
    )}
  </>
);

ServiceDates.propTypes = {
  startsAt: PropTypes.string.isRequired,
  endsAt: PropTypes.string.isRequired,
  serviceDuration: PropTypes.number,
  serviceDurationStartTime: PropTypes.string,
  paymentType: PropTypes.string.isRequired,
};

ServiceDates.defaultProps = {
  serviceDuration: 0,
  serviceDurationStartTime: '',
};

export default ServiceDates;
